import Icon from './component'

export default Icon
